import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RegisterPermissionType } from '@assetaccountant/api/models/register-permission-type';
import { DynamicsConnection } from '@assetaccountant/integrations/models/dynamics/dynamics-connection';
import { MicrosoftDynamicsService } from '@assetaccountant/integrations/services/dynamics.service';

@Component({
  selector: 'app-dynamics-launch-tenant',
  templateUrl: './dynamics-launch-tenant.component.html',
  styleUrls: ['./dynamics-launch-tenant.component.scss'],
  standalone: false,
})
export class DynamicsLaunchTenantComponent implements OnInit {
  @Input() connection?: DynamicsConnection;

  @Output() onConnectClicked = new EventEmitter();
  @Output() onDisconnectClicked = new EventEmitter();

  readonly RegisterPermission = RegisterPermissionType;

  constructor(private dynamicsService: MicrosoftDynamicsService) {}

  get title() {
    return { pageTitle: `Dynamics App Launcher` };
  }

  ngOnInit() {
    // Migration: the SPA no longer performs a Duende AzureAD re-login to pull the Dynamics tenant out
    // of the id-token (users authenticate via the LeaseQuery "APIAuth" cookie and hold no client-side
    // token/tenant). The Dynamics tenant is established by the Dynamics OAuth flow itself — which is
    // independent of the login IdP — so kick that off directly.
    //
    // NOTE: this drops the previous "if the tenant already has connection(s), navigate straight to the
    // register / org" short-circuit (it required a client-side tenantId that no longer exists). Revisit
    // once the server can resolve the tenant's existing Dynamics connections without a login-token tenant.
    this.dynamicsService.initiateOAuth(location.href);
  }
}
